<template>
  <div id="publicClass_details">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="box_top clearfix w1200">
      <dl class="clearfix">
        <dt class="fl"><img :src="kcBigList.CoverImg" /></dt>
        <dd class="fl course_card">
          <!-- <div class="ClassTypeName">
            {{ kcBigList.ClassTypeName }}
          </div> -->
          <div>
            <h2>{{ kcBigList.Title }}</h2>
          <div class="classTime">
            <img src="../../assets/publicClass/classTime.png" />
            {{ PlanOpenDate }}开班
          </div>
          </div>
          <div>
            <div class="timeUpClass">
            <div>班型：{{ kcBigList.ClassTypeName }}</div>
            <div>上课时间：{{ SchoolTime + "-" + QuittingTime }}</div>
            <div class="gray_text">具体课次时间以实际课程时间为准</div>
          </div>
          <div class="Price">
            <strong
              >￥{{ kcBigList.Price
              }}<i> /{{ kcBigList.ClassHour }}课时</i></strong
            >
            <span
              @click="toLive800"
              v-if="[28, 29, 30].indexOf(kcBigList.ClassType - 0) > -1"
              >咨询享优惠</span
            >
            <span
              :class="[onOff == true ? 'PurchasedActive' : 'ljyy']"
              v-else
              @click="course_order"
              >{{ onOff == true ? "已购买" : "立即购买" }}</span
            >
          </div>
          </div>
        </dd>
      </dl>
    </div>
    <!-- box_top end -->
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">
        <strong>您当前所在位置：</strong><a href="/">首页</a> &gt;&gt;
        <router-link :to="{ path: '/course_list?nav=8' }">课程列表</router-link>
        &gt;&gt; <span>{{ kcBigList.Title }}</span>
      </div>
    </div>
    <!-- hotgkt end -->
    <div class="main">
      <div class="main_top w1200">
        <div id="tab-tilte1">
          <ul>
            <li @click="curClick(0)" :class="{ active: cur == 0 }">
              课程介绍<i></i>
            </li>
            <li @click="curClick(1)" :class="{ active: cur == 1 }">
              课程目录<i></i>
            </li>
            <li @click="curClick(2)" :class="{ active: cur == 2 }">
              师资介绍<i></i>
            </li>
            <li @click="curClick(3)" :class="{ active: cur == 3 }">
              服务体系<i></i>
            </li>
            <li @click="curClick(4)" :class="{ active: cur == 4 }">
              常见问题<i></i>
            </li>
          </ul>
        </div>
        <!-- tab-tilte end -->
        <div id="tab-content">
          <!-- 课程介绍 -->
          <div v-show="cur == 0">
            <div class="introduction">
              <div class="courseXy">
                <h2><span>01</span>适合学员</h2>
                <ul class="clearfix">
                  <li v-for="(item, index) in ApplyStudentType" :key="index">
                    <div class="of2">
                      <span>{{
                        index < 9 ? "0" + (index + 1) : "" + (index + 1)
                      }}</span
                      >{{ item }}
                    </div>
                  </li>
                </ul>
              </div>
              <div class="courseDg">
                <h2><span>02</span>教学大纲</h2>
                <table>
                  <tr>
                    <th width="400">类别</th>
                    <th>详情</th>
                  </tr>
                  <tr v-for="(item, index) in kcBigList.Syllabus" :key="index">
                    <td class="td1" align="center" valign="center">
                      {{ item.Name }}
                    </td>
                    <td class="td2">{{ item.Value }}</td>
                  </tr>
                </table>
              </div>
              <div class="courseLd">
                <h2><span>03</span>课程亮点</h2>
                <ul class="clearfix">
                  <li v-for="(item, index) in CourseHighlights" :key="index">
                    <p>
                      {{ item }}
                      <em></em>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 课程目录 -->
          <div v-show="cur == 1">
            <div
              class="catalog"
              v-for="(item5, index5) in CataloguesList"
              :key="index5"
            >
              <template v-if="item5.Catalogues.length > 0">
                <div
                  class="catalog_title_"
                  v-if="pageType == 2 && item5.Title"
                  @click="titleCollapse(index5, item5.Id)"
                >
                  <div
                    class="left cursor_pointer"
                    @click.stop="toDetail(item5.Id)"
                  >
                    <img :src="item5.CoverImg" alt="" class="img" />
                  </div>
                  <div class="middle_title">
                    <div
                      class="title width_ellipsis cursor_pointer"
                      @click.stop="toDetail(item5.Id)"
                    >
                      {{ item5.Title }}
                    </div>
                    <div class="tip">&nbsp;</div>
                    <div class="tag_box">
                      <span class="tag_item">{{
                        item5.ClassType == "28"
                          ? "大班课"
                          : item5.ClassType == "29"
                          ? "小班课"
                          : item5.ClassType == "30"
                          ? "一对一"
                          : "视频课"
                      }}</span>
                    </div>
                  </div>
                  <div class="middle_money">
                    <span class="num">{{ item5.ClassHour }}/课时</span>
                    <span class="money"
                      >￥{{
                        item5.Price ? item5.Price : "0" | toFixSecond
                      }}</span
                    >
                  </div>
                  <div class="right">
                    <img
                      src="../../assets/publicClass/kecheng_icon_drop-down.png"
                      alt=""
                      v-show="!item5.isUnfold"
                      class="img_"
                    />
                    <img
                      src="../../assets/publicClass/kecheng_icon_drop-up.png"
                      alt=""
                      class="img_"
                      v-show="item5.isUnfold"
                    />
                  </div>
                </div>
                <div
                  class="catalog_chapter"
                  :style="{
                    display: pageType == 2 && item5.Title ? 'none' : 'block'
                  }"
                  :class="`catalog_chapter_${item5.Id}`"
                  v-for="(items, index) in item5.Catalogues"
                  :key="index"
                >
                  <div v-for="(item, indexs) in items" :key="indexs">
                    <div class="catalog_chapter_p" v-if="item.Type == 1">
                      <i></i><span></span>{{ item.Title }}
                    </div>
                    <div class="catalog_section" v-if="item.Type == 2">
                      <div class="catalog_section_p clearfix">
                        <div class="left">
                          <i>
                            <img
                              src="../../assets/courselist/live.png"
                              v-if="kcBigList.ClassTypeName != '视频课'"
                            />
                            <img
                              src="../../assets/courselist/video.png"
                              v-else
                            />
                          </i>
                          <span
                            class="sp1"
                            v-if="items.length && items[0].Type == 1"
                            >第{{ indexs }}节</span
                          >
                          <span
                            class="sp1"
                            v-if="items.length && items[0].Type == 2"
                            >第{{ indexs + 1 }}节</span
                          >
                          <span class="sp2"
                            >{{ item.Title
                            }}<strong v-if="item.IsTrial" class="mf"
                              >免费试学</strong
                            ></span
                          >
                          <strong
                            v-if="kcBigList.ClassTypeName == '视频课'"
                            class="time"
                            >{{ item.Duration }}</strong
                          >
                        </div>
                        <div class="right">
                          <div
                            class="clearfix"
                            v-if="kcBigList.ClassTypeName != '视频课'"
                          >
                            <div v-if="DateTime >= item.jsTimeTemp">
                              <div v-if="item.VideoId || item.TxVideoId">
                                <span
                                  class="hf"
                                  @click="
                                    watchlog2(
                                      3,
                                      item.Id,
                                      item.RoomId,
                                      item.VideoToken,
                                      item.TxVideoId,
                                      item.Title
                                    )
                                  "
                                  v-if="item.IsTrial || onOff"
                                  >查看回放</span
                                >
                              </div>
                            </div>
                            <div v-else-if="DateTime >= item.ksTimeTemp">
                              <span
                                v-if="onOff"
                                class="zb"
                                @click="studio(1, item.RoomId, 48, item5.Id)"
                                >进入直播间</span
                              >
                            </div>
                          </div>
                          <div class="clearfix" v-else>
                            <div v-if="item.IsTrial || onOff">
                              <span
                                class="sp"
                                @click="
                                  watchlog2(
                                    2,
                                    item.Id,
                                    item.VideoId,
                                    item.VideoToken,
                                    item.TxVideoId,
                                    item.Title
                                  )
                                "
                                v-if="item.VideoId || item.TxVideoId"
                                >查看视频</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- 师资介绍 end -->
          <div v-show="cur == 2">
            <div class="teacher">
              <ul class="clearfix">
                <li class="fl" v-for="(item, index) in StaffsList" :key="index">
                  <div class="top clearfix">
                    <span class="of1">{{ item.CourseScore }}</span>
                    <strong class="of1">{{ item.Academic }}</strong>
                  </div>
                  <div class="img">
                    <img :src="item.HeadUrl" />
                  </div>
                  <div class="bottom clearfix">
                    <div class="left">
                      <strong>{{ item.Name }}</strong>
                      <p><span>教授科目：</span>{{ item.CourseTypeName }}</p>
                      <p><span>讲授课程：</span>{{ item.SubjectTypeName }}</p>
                    </div>
                    <div class="right" v-if="item.TeacherVideoUrl">
                      <video
                        width="210"
                        height="120"
                        controls
                        :poster="CoverImg"
                        v-if="item.TeacherVideoUrl"
                      >
                        <source :src="item.TeacherVideoUrl" />
                        您的浏览器不支持 video 标签。
                      </video>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 服务体系 end -->
          <div v-show="cur == 3">
            <div class="introduction">
              <div class="courseGh">
                <h2><span>01</span>课程规划</h2>
                <ul class="clearfix">
                  <li v-for="(item, index) in CoursePlanning" :key="index">
                    {{ item }}
                  </li>
                </ul>
                <div class="icon">
                  <img src="../../assets/courselist/courseGh.png" />
                </div>
              </div>
              <div class="courseFw">
                <h2><span>02</span>增值服务</h2>
                <div class="courseFwBox">
                  <ul class="clearfix">
                    <li v-for="(item, index) in AddedServices" :key="index">
                      <em></em>{{ item }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- 常见问题 -->
          <div v-show="cur == 4">
            <ul class="feedback">
              <li>
                <h2><span>1</span>如何购买课程？</h2>
                <p>
                  如需购买课程，请您先注册并成功登录启德考培在线，选择需要购买的课程进入课程页查看课程详细介绍。点击“咨询享优惠添加网课顾问，添加成功后便可咨询购课。
                </p>
              </li>
              <li>
                <h2><span>2</span>如何上课？</h2>
                <p>
                  购买课程后，顾问老师会操作进班流程。成功加入课程所在班级后，登录启德考培在线网页或APP，依次点击【个人中心【学习任务中心】-【我的课程】即可查看班级课表，在课程开始时可以点击进入直播课开始上课。
                </p>
              </li>
              <li>
                <h2><span>3</span>客服电话？</h2>
                <p>
                  如有课程相关疑问，可以在客服工作时间内随时拨打电话
                  400-002-2508 进行咨询。
                </p>
              </li>
            </ul>
          </div>
          <!-- tab-tilte 3 end -->
        </div>
        <!-- tab-content end -->
      </div>
    </div>
    <!-- main end -->

    <div class="qide_modal_bg" v-if="qideModal" @click="qideModal = false">
      <div
        class="qide_modal"
        @click.stop="
          '';

        "
      >
        <img
          class="qide_modal_bgc"
          src="../../assets/courselist/modal_bgc.png"
        />
        <img
          src="../../assets/courselist/qide_code.png"
          class="code_qide"
          alt=""
        />
        <span class="close_icon" @click.stop="qideModal = false"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

export default {
  components: {
    // 将组件隐射为标签,登录弹窗
    Header
  },
  metaInfo() {
    return {
      title: this.setting.title,
      meta: [
        {
          name: "keywords",
          content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      ClassType: "",
      qideModal: false,
      setting: {
        title: "启德考培旗下在线课堂_出国考试在线培训_考培网校"
      },
      tokenkey: "",
      onOff: "", //是否购买
      anys: 0,
      Ids: "", //课程ID
      cur: 0,
      scroll: "",
      position: false,
      kcBigList: "", //课程大内容
      ApplyStudentType: "", //适合的人群
      CoverVideo: "", //短视频
      CoverImg: "", //短视频封面
      CourseCatalogue: "", //课程标题（课程目录）
      Catalogues: "", //课程目录
      ClassPrice: "", //师资介绍
      dw_course: false,
      AuditionList: [], //试听视频
      ClassId: "", //班级Id
      addClassId: "", //已加入班级ID
      couponsList: "", //优惠券
      RegisterStatus: "", //是否加入班级状态
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],

      DateTime: "",
      ksTime: [],
      jsTime: [],
      tanZzc: false,
      classImg: "",
      classVideo: "",
      liveTan: false, //视频弹窗

      ison: true, //是否为测试课
      CataloguesList: [], // 目录数据
      pageType: "", //1:正常 2：课程包

      PlanOpenDate: "",
      SchoolTime: "",
      QuittingTime: "",
      CourseHighlights: [], //课程亮点
      StaffsList: [],
      CoursePlanning: [],
      AddedServices: []
    };
  },
  watch: {
    $route(to, from) {
      console.log("to", to);
      console.log("from", from);
      if (to.query.Id != from.query.Id) {
        this.$router.go(0);
      }
    }
  },
  methods: {
    //加载登录后信息
    reloads() {
      let that = this;
      that.tokenkey = that.$cookies.get("token");
      //是否已购买课程
      let classId = this.$route.query.Id;

      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/BuyCourseStatus?courseId=" +
            classId +
            "&contentType=48",
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          // console.log(result)
          if (result.data.results != null) {
            that.addClassId = result.data.results;
          }
          that.nowLoading();
          //已支付直接跳转
          if (result.data.code == 200) {
            if (result.data.succ) {
              // // console.log('已购买')
              that.onOff = true;
            } else {
              that.onOff = false;
            }
          }
        })
        .catch(function(error) {
          // console.log(error);
        });

      //是否关注
      that.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/CollectionStatus?contentId=" +
            that.Ids,
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(response) {
          if (response.data.code == 2) {
            that.anys = 0;
          } else {
            that.anys = 1;
          }
        })
        .catch(function(err) {
          // console.log(err);
          // console.log('数据错误');
        });
      //优惠券
      that.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/CourseCoupon?courseId=" +
            that.Ids,
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(response) {
          // // console.log(response.data)
          that.couponsList = response.data.results;
        })
        .catch(function(err) {
          // console.log(err);
          // console.log('数据错误');
        });
    },
    // 系统时间
    ServerDateTime() {
      let that = this;
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/ServerDateTime")
        .then(function(result) {
          let resultsT = new Date(
            result.data.results.replace("-", "/").replace("-", "/")
          );
          that.DateTime = parseInt(resultsT.getTime() / 1000) + 600;
          // console.log("that.DateTime", that.DateTime)
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
    },
    curClick(index) {
      let that = this;
      this.cur = index;
    },
    //转换二维数组
    handelArray(array, arr = []) {
      if (array) {
        for (let i = 0; i < array.length; i++) {
          if (array[i].Type === 1) {
            arr.push([array[i]]);
          } else {
            if (arr.length == 0) {
              arr.push([array[i]]);
            } else {
              arr[arr.length - 1].push(array[i]);
            }
          }
        }
        return arr;
      }
    },
    //初始加载
    nowLoading() {
      let that = this;
      that.tokenkey = that.$cookies.get("token");
      //获取枚举列表
      let enumBox = sessionStorage.getItem("enum");
      that.enumList = JSON.parse(enumBox);
      that.Ids = this.$route.query.Id;
      that.ison = this.$route.query.IsOn || true;
      localStorage.setItem("Ids", that.Ids);
      return new Promise(function(resolve, reject) {
        resolve(
          that.$http
            .get(
              "https://schoolapi.eiceducation.com.cn/api/Course/" +
                that.Ids +
                "?classId=" +
                that.addClassId +
                "&ison=" +
                that.ison,
              {
                headers: {
                  token: that.tokenkey
                }
              }
            )
            .then(function(response) {
              let { results } = response.data;
              that.kcBigList = results;
              if (results.CourseClasses) {
                that.PlanOpenDate =
                  results.CourseClasses.PlanOpenDate.substring(0, 10)
                    .replace("-", "年")
                    .replace("-", "月") + "日"; //开班时间
                that.SchoolTime = results.ClassScheduleList.SchoolTime.substring(
                  11,
                  19
                );
                that.QuittingTime = results.ClassScheduleList.QuittingTime.substring(
                  11,
                  19
                ); //上课时间
              }
              that.setting.title =
                that.kcBigList.Title +
                " - 启德考培旗下在线课堂_出国考试在线培训_考培网校";
              localStorage.setItem("Title", that.kcBigList.Title);
              if (that.kcBigList.ApplyStudentType) {
                let str = that.kcBigList.ApplyStudentType.split(",");
                that.ApplyStudentType = str; //适合人群
              }
              if (that.kcBigList.CourseHighlights) {
                let str = that.kcBigList.CourseHighlights.split(",");
                that.CourseHighlights = str; //适合人群
              }
              that.kcBigList.Syllabus = JSON.parse(that.kcBigList.Syllabus);
              that.CoverVideo = that.kcBigList.CoverVideo; //短视频
              that.CoverImg = that.kcBigList.CoverImg; //短视频封面
              that.ClassType = that.kcBigList.ClassType; //班级类型
              that.pageType = results.Type;
              console.log("this.pageType", that.pageType);
              //课程目录
              that.Catalogues = that.kcBigList.Catalogues; //课程标题

              let CataloguesList = results.Catalogues || [];
              for (let row of CataloguesList) {
                row.Catalogues = that.handelArray(row.Catalogues);
                if (row.ApplyStudentType) {
                  row.ApplyStudentTypeArr = row.ApplyStudentType.split(",");
                }
                for (let i in row.Catalogues) {
                  for (let j in row.Catalogues[i]) {
                    if (row.Catalogues[i][j].SchoolTime != null) {
                      row.Catalogues[i][j].SchoolTime = row.Catalogues[i][
                        j
                      ].SchoolTime.replace("-", "/").replace("-", "/");
                      row.Catalogues[i][j].ksTimeTemp =
                        new Date(row.Catalogues[i][j].SchoolTime).getTime() /
                        1000;
                    }
                    if (row.Catalogues[i][j].QuittingTime != null) {
                      row.Catalogues[i][j].QuittingTime = row.Catalogues[i][
                        j
                      ].QuittingTime.replace("-", "/").replace("-", "/");
                      row.Catalogues[i][j].jsTimeTemp =
                        new Date(row.Catalogues[i][j].QuittingTime).getTime() /
                        1000;
                    }
                  }
                }
              }
              that.CataloguesList = CataloguesList;
              console.log("CataloguesList", CataloguesList);
              // that.ksTime = ksTime;
              // that.jsTime = jsTime;
              // console.log('ksTime',ksTime);
              // console.log('ksTime',ksTime);
              //师资介绍
              if (that.kcBigList.ClassPrice) {
                that.ClassPrice = that.kcBigList.ClassPrice;
              }
              if (that.kcBigList.StaffList) {
                that.StaffsList = that.kcBigList.StaffList;
              }
              if (that.kcBigList.CoursePlanning) {
                let str = that.kcBigList.CoursePlanning.split(",");
                that.CoursePlanning = str; //课程规划
              }
              console.log(that.SynopsisText, "that.SynopsisText");
              if (that.kcBigList.AddedServices) {
                let str = that.kcBigList.AddedServices.split(",");
                that.AddedServices = str; //增值服务
              }
              console.log(that.AddedServices, "that.AddedServices");
              //是否有下设班级
              if (that.kcBigList.ClassTypeName != "视频课") {
                that.dw_course = true;
              }
              // console.log("dw_course", that.kcBigList)
              //试听视频
              that.AuditionList = that.kcBigList.AuditionList;

              console.log(that.kcBigList, "that.kcBigList");
            })
            .catch(function(err) {
              // console.log(err);
              // console.log('数据错误');
            })
        );
      });
    },
    //tyoeid播放类型 1直播/2点播/3回放
    //roomid 房间号
    //按钮类型contentType 48直播
    //that.addClassId 班级id
    async studio(tyoeid, roomid, contentType, id) {
      let that = this;
      let addClassId = that.addClassId;
      let Id = id ? id : this.$route.query.Id;
      let flag = true;
      await this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/BuyCourseStatus?courseId=" +
            Id +
            "&contentType=48",
          {
            headers: {
              "content-type": "application/json; charset=utf-8",
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          if (result.data.code == 200) {
            if (result.data.results != null) {
              addClassId = result.data.results;
            }
          } else if (result.data.code == 2) {
            flag = false;
            //未支付，走支付流程
            that.$router.push({
              path: "/course_order",
              query: {
                Id
              }
            });
            return;
          }
        })
        .catch(function(error) {});
      if (!flag) {
        return;
      }
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/BJYSign?contentType=" +
            contentType +
            "&contentId=" +
            addClassId +
            "&roomid=" +
            roomid,
          {
            headers: {
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          // // console.log(result)
          if (result.data.succ) {
            let room_id = roomid; //房间号
            let user_number = that.$refs.header.UserInfo.Number; //用户数字ID
            let user_role = 0; //用户身份0:学生 1:老师 2:管理员
            let user_name = that.$refs.header.UserInfo.NickName; //用户名
            let user_avatar = that.$refs.header.UserInfo.HeadUrl; //用户头像
            let sign = result.data.results; //用户签名
            let web_url =
              "https://b96135432.at.baijiayun.com/web/room/enter?room_id=" +
              roomid +
              "&user_number=" +
              user_number +
              "&user_role=" +
              user_role +
              "&user_name=" +
              user_name +
              "&user_avatar=" +
              user_avatar +
              "&sign=" +
              sign;
            window.open(web_url);
          } else {
            that.$message.error(result.data.msg);
          }
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
      // this.WatchLogJL(tyoeid, scheduleId, videoid)
    },
    watchlog2(tyoeid, scheduleId, videoid, videotoken, TxVideoId, title) {
      let that = this;
      // 1直播/2点播/3回放
      if (TxVideoId) {
        window.open(
          "https://online.eickaopei.com/video.html?title=" +
            title +
            "&id=" +
            TxVideoId,
          "_blank"
        );
        return;
      }
      if (tyoeid == 2) {
        window.open(
          "https://b96135432.at.baijiayun.com/web/video/player?vid=" +
            videoid +
            "&token=" +
            videotoken +
            "&player=h5&user_number=" +
            that.$parent.UserInfos.Number +
            "&user_name=" +
            that.$parent.UserInfos.NickName,
          "_blank"
        );
      } else {
        window.open(
          "https://b96135432.at.baijiayun.com/web/playback/index?classid=" +
            videoid +
            "&token=" +
            videotoken +
            "&player=h5&user_number=" +
            that.$parent.UserInfos.Number +
            "&user_name=" +
            that.$parent.UserInfos.NickName,
          "_blank"
        );
      }
      this.WatchLogJL(tyoeid, scheduleId, videoid);
    },
    //记录观看次数
    WatchLogJL(tyoeid, scheduleId, videoid) {
      let that = this;
      this.$http
        .post(
          "https://schoolapi.eiceducation.com.cn/api/WatchLog",
          {
            Type: tyoeid,
            CourseId: that.$route.query.Id,
            ScheduleId: scheduleId,
            VideoId: videoid
          },
          {
            headers: {
              token: that.tokenkey
            }
          }
        )
        .then(function(result) {
          // // console.log(result)
          // that.Catalogue(that.$route.query.courseId, that.$route.query.classId)
        })
        .catch(function(error) {
          // console.log(error);
        });
    },
    tanZzcClass() {
      this.tanZzc = false;
      this.liveTan = false; //视频弹窗
      this.classVideo = "";
    },
    classLiveTan(classLiveTan) {
      this.tanZzc = true;
      this.liveTan = true; //视频弹窗
      this.classVideo = classLiveTan;
    },
    titleCollapse(index, id) {
      let flag = this.CataloguesList[index].isUnfold ? false : true;
      this.$set(this.CataloguesList[index], "isUnfold", flag);
      if (!flag) {
        $(`.catalog_chapter_${id}`).slideUp();
      } else {
        $(`.catalog_chapter_${id}`).slideDown();
      }
    },
    //跳转课程详情
    toDetail(Id) {
      this.$router.push({
        path: "/course_details",
        query: {
          Id,
          nav: this.$route.query.nav
        }
      });
    },
    toLive800() {
      this.qideModal = true;
    },
    course_order() {
      let that = this;
      if (that.tokenkey) {
        let classId = this.$route.query.Id;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/BuyCourseStatus?courseId=" +
              classId +
              "&contentType=48",
            {
              headers: {
                "content-type": "application/json; charset=utf-8",
                token: that.tokenkey
              }
            }
          )
          .then(function(result) {
            // // console.log(result)
            //已支付直接跳转
            if (result.data.code == 200) {
              if (result.data.succ) {
                that.$message.warning("已经购买过此课程");
                that.onOff = true;
              }
            } else if (result.data.code == 2) {
              that.onOff = false;

              if ([28, 29, 30].indexOf(that.ClassType - 0) > -1) {
                that.qideModal = true;
              } else {
                //  未支付，走支付流程
                that.$router.push({
                  path: "/course_order",
                  query: {
                    Id: classId
                  }
                });
              }
              // let data = JSON.stringify(that.listDetails)
              // localStorage.setItem('data1',data);
            }
          })
          .catch(function(error) {
            // console.log(error);
          });
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
      //课程contentType=48（公开课是183）
    }
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    // console.log("that.$parent",that.$parent.UserInfos)
    this.ServerDateTime();
    var doc = document.documentElement;
    $(doc).animate(
      {
        scrollTop: 0
      },
      0
    );
    that.nowLoading();
    if (!that.tokenkey) {
      return;
    }
    that.reloads();
    if (that.$route.query.active) {
      that.curClick(that.$route.query.active);
    }
  }
};
</script>

<style scoped>
#publicClass_details {
  background: #fbfbfb;
}

.box_top {
  box-sizing: border-box;
  position: relative;
  background-color: #fff;
}

.box_top dl dt {
  width: 800px;
  height: 420px;
  overflow: hidden;
  float: left;
}

.box_top dl dt img {
  width: 100%;
  margin-top: -50px;
}

.box_top dl dd {
  width: 400px;
  height: 420px;
  float: left;
  position: relative;
  padding: 0 20px;
}

.box_top dl dd .ClassTypeName {
  padding: 0 14px;
  height: 32px;
  background: #ff0659;
  border-radius: 0px 0px 0px 0px;
  position: absolute;
  left: 20px;
  top: 0;
  font-weight: 400;
  font-size: 12rpx;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
}

.box_top dl dd h2 {
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 32px;
  text-align: left;
  padding: 52px 0 20px;
}

.box_top dl dd .classTime {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 24px;
  margin-bottom: 40px;
}

.box_top dl dd .classTime img {
  display: block;
  float: left;
  width: 24px;
  height: 24px;
}
.box_top dl .course_card{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}
.box_top dl dd .timeUpClass {
  background: #fbfbfb;
  padding: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  margin-bottom: 30px;
}

.box_top dl dd .timeUpClass .gray_text {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 14px;
  margin-top: 8px;
}

.box_top dl dd .Price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  background: rgba(255, 6, 89, 0.98);
  border-radius: 0px 0px 0px 0px;
  text-align: center;
  padding: 0 20px;
  margin-left: -20px;
}

.box_top dl dd .Price strong {
  display: block;
  width: 240px;
  font-size: 24px;
  font-weight: 400;
  color: #fff;
  text-align: left;
}

.box_top dl dd .Price strong i {
  font-size: 12px;
  font-weight: normal;
}

.box_top dl dd .Price span {
  display: block;
  width: 120px;
  height: 30px;
  background: #ffffff;
  border-radius: 15px 15px 15px 15px;
  font-weight: 400;
  font-size: 16px;
  color: #ff0659;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}

.BreadcrumbNavigation {
  width: 1200px;
  text-align: left;
  font-size: 20px;
  line-height: 75px;
  margin: 0 auto;
  color: #337cff;
}

.BreadcrumbNavigation strong {
  color: #666666;
  font-weight: normal;
}

.BreadcrumbNavigation a {
  font-size: 20px;
  color: #337cff;
}

.BreadcrumbNavigation span {
  font-size: 20px;
  color: #333333;
}

.main {
  padding-bottom: 70px;
  position: relative;
}

.main_top {
  width: 1200px;
}

#tab-tilte1 {
  width: 1200px;
  height: 70px;
  background: #ffffff;
  border-radius: 35px 35px 35px 35px;
  position: relative;
}

#tab-tilte1 ul {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

#tab-tilte1 ul li {
  font-size: 24px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  line-height: 70px;
  padding: 0 40px;
}

#tab-tilte1 ul li.active {
  height: 70px;
  position: relative;
  color: rgba(255, 6, 89, 1);
  font-weight: 500;
}

#tab-tilte1 ul li.active i {
  display: block;
  width: 50px;
  height: 5px;
  background: #ff0659;
  border-radius: 3px 3px 3px 3px;
  position: absolute;
  left: 50%;
  bottom: 0;
  margin-left: -16px;
}

#tab-tilte1 ul li {
  cursor: pointer;
}

#tab-content {
  padding-top: 32px;
}

.main_top .introduction {
  width: 100%;
}

.main_top .introduction h2 {
  padding-bottom: 16px;
  width: 1200px;
  border-bottom: 1px solid #d8d8d8;
  font-weight: 500;
  font-size: 26px;
  color: #333333;
  line-height: 38px;
  text-align: left;
  margin-bottom: 30px;
}

.main_top .introduction h2 span {
  font-weight: 500;
  font-size: 32px;
  color: #ff0659;
  line-height: 38px;
  padding-right: 10px;
}

.main_top .introduction .courseXy {
  padding-bottom: 30px;
}

.main_top .introduction .courseXy ul li {
  display: flex;
  align-items: center;
  float: left;
  width: 165px;
  height: 125px;
  position: relative;
  padding-left: 25px;
  padding-top: 33px;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
  line-height: 30px;
  margin-bottom: 20px;
  padding-right: 110px;
}

.main_top .introduction .courseXy ul li:nth-child(1n) {
  background: url(../../assets/courselist/ld1.png) no-repeat;
  background-size: 300px 155px;
}

.main_top .introduction .courseXy ul li:nth-child(2n) {
  background: url(../../assets/courselist/ld2.png) no-repeat;
  background-size: 300px 155px;
}

.main_top .introduction .courseXy ul li:nth-child(3n) {
  background: url(../../assets/courselist/ld3.png) no-repeat;
  background-size: 300px 155px;
}

.main_top .introduction .courseXy ul li:nth-child(4n) {
  background: url(../../assets/courselist/ld4.png) no-repeat;
  background-size: 300px 155px;
}

.main_top .introduction .courseXy ul li span {
  position: absolute;
  font-weight: 700;
  font-size: 24px;
  color: #ffffff;
  line-height: 38px;
  position: absolute;
  top: 7px;
  left: 25px;
}

.main_top .introduction .courseDg {
  padding-bottom: 50px;
}

.main_top .introduction .courseLd {
  padding-bottom: 50px;
}

.main_top .introduction .courseLd ul li {
  display: flex;
  align-items: flex-start;
  float: left;
  width: 345px;
  height: 78px;
  position: relative;
  padding-left: 42px;
  padding-top: 24px;
  margin-bottom: 20px;
  margin-right: 18px;
}

.main_top .introduction .courseLd ul li p {
  width: 172px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 22px;
  position: relative;
  padding-bottom: 10px;
  min-height: 40px;
}

.main_top .introduction .courseLd ul li p em {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: #333333;
  border-radius: 3px 3px 3px 3px;
}

.main_top .introduction .courseLd ul li:nth-child(1n) {
  background: url(../../assets/courselist/ld01.png) no-repeat;
  background-size: 387px 104px;
}

.main_top .introduction .courseLd ul li:nth-child(2n) {
  background: url(../../assets/courselist/ld02.png) no-repeat;
  background-size: 387px 104px;
}

.main_top .introduction .courseLd ul li:nth-child(3n) {
  background: url(../../assets/courselist/ld03.png) no-repeat;
  background-size: 387px 104px;
  margin-right: 0;
}

.main_top .introduction .courseDg table {
  width: 100%;
}

.main_top .introduction .courseDg table th {
  height: 50px;
  background: #878dff;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}

.main_top .introduction .courseDg table tr:nth-child(odd) {
  background: rgba(135, 141, 255, 0.05);
}

.main_top .introduction .courseDg table .td1 {
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
  text-align: center;
  vertical-align: middle;
  border-right: 1px #d8d8d8 solid;
  border-bottom: 1px #d8d8d8 solid;
  border-left: 1px #d8d8d8 solid;
  white-space: pre-wrap;
}

.main_top .introduction .courseDg table .td2 {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 32px;
  text-align: left;
  padding: 10px 20px;
  border-bottom: 1px #d8d8d8 solid;
  border-right: 1px #d8d8d8 solid;
  white-space: pre-wrap;
}

.main_top .catalog {
  width: 1200px;
  margin: 0 auto;
}

.main_top .catalog .catalog_chapter {
  margin-bottom: 36px;
  /* display: none; */
}

.main_top .catalog .catalog_chapter h2 {
  font-size: 20px;
  color: #333;
  line-height: 30px;
  padding-left: 28px;
  margin-bottom: 15px;
}

.main_top .catalog .catalog_chapter_p {
  padding: 12px 10px;
  font-size: 18px;
  color: #333;
  line-height: 28px;
  text-align: left;
  background: #f5f6f6;
}

.main_top .catalog .catalog_chapter_p span {
  float: left;
  margin-right: 20px;
}

.main_top .catalog .catalog_chapter_p i {
  display: inline-block;
  width: 6px;
  height: 12px;
  background: #d5d5d5;
  border-radius: 3px;
  vertical-align: middle;
  float: left;
  margin-right: 12px;
  margin-top: 8px;
}

.main_top .catalog .catalog_section_p {
  border-bottom: 1px #d5d5d5 solid;
  padding: 20px 0;
}

.main_top .catalog .catalog_chapter > div:nth-child(even) {
  background: linear-gradient(
    90deg,
    rgba(251, 251, 251, 0) 1%,
    #ffffff 54%,
    rgba(251, 251, 251, 0) 100%
  );
}

.main_top .catalog .catalog_section_p i {
  display: inline-block;
  width: 36px;
  height: 36px;
  vertical-align: middle;
  float: left;
  margin-right: 30px;
}

.main_top .catalog .catalog_section_p i img {
  display: block;
  width: 36px;
  height: 36px;
}

.main_top .catalog .catalog_section_p .sp1 {
  width: 110px;
  float: left;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 36px;
  text-align: left;
}

.main_top .catalog .catalog_section_p .sp2 {
  display: inline-block;
  width: 640px;
  float: left;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 36px;
}

.main_top .catalog .catalog_section_p .mf {
  display: inline-block;
  width: 80px;
  height: 20px;
  line-height: 20px;
  background: #ff7373;
  border-radius: 10px;
  font-size: 12px;
  color: #fff;
  font-weight: normal;
  text-align: center;
  margin-left: 10px;
}

.main_top .catalog .catalog_section_p .time {
  display: inline-block;
  width: 145px;
  font-size: 16px;
  color: #999999;
  font-weight: 400;
  text-align: right;
  line-height: 36px;
}

.main_top .catalog .catalog_section_p .right {
  padding: 3px 0;
}

.main_top .catalog .catalog_section_p .right span {
  display: inline-block;
  width: 98px;
  height: 28px;
  border-radius: 15px 15px 15px 15px;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 28px;
}

.main_top .catalog .catalog_section_p .right .hf {
  color: #fff;
  background: #ffae00;
  border: 1px solid #ffae00;
}

.main_top .catalog .catalog_section_p .right .zb {
  background: #337cff;
  color: #fff;
  border: 1px solid #337cff;
}

.main_top .catalog .catalog_section_p .right .sp {
  background: #ff7e7e;
  color: #fff;
  border: 1px solid #ff7e7e;
}

.main_top .teacher {
  width: 1200px;
}

.main_top .teacher ul li {
  width: 530px;
  height: 554px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 30px;
  float: left;
}

.main_top .teacher ul li:nth-child(2n) {
  margin-right: 0;
}

.main_top .teacher ul li .top {
  margin-bottom: 28px;
}

.main_top .teacher ul li .top span {
  display: inline-block;
  max-width: 200px;
  height: 30px;
  border: 1px solid #ff0659;
  font-weight: 400;
  font-size: 20px;
  color: #ff0659;
  line-height: 30px;
  padding: 0 12px;
  float: left;
}

.main_top .teacher ul li .top strong {
  display: inline-block;
  max-width: 300px;
  font-weight: 400;
  font-size: 26px;
  color: #000000;
  line-height: 30px;
  float: right;
}

.main_top .teacher ul li .img {
  width: 530px;
  height: 320px;
  overflow: hidden;
  margin-bottom: 30px;
  background: url(../../assets/courselist/teacherBj.png) no-repeat;
  background-size: 530px 350px;
  padding-top: 30px;
}

.main_top .teacher ul li .img img {
  display: block;
  height: 320px;
  margin: 0 auto;
}

.main_top .teacher ul li .bottom .left {
  border-left: 1px #ff0659 solid;
  padding-left: 20px;
  width: 300px;
  padding-left: 19px;
}

.main_top .teacher ul li .bottom .left strong {
  display: block;
  font-weight: 700;
  font-size: 30px;
  color: #000000;
  line-height: 30px;
  margin-bottom: 10px;
}

.main_top .teacher ul li .bottom .left p {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 32px;
}

.main_top .teacher ul li .bottom .left p span {
  color: #333333;
}

.main_top .teacher ul li .bottom .right {
  width: 210px;
  height: 120px;
  background: #000000;
}

.main_top .teacher ul li .bottom .right video {
  display: block;
}

.main_top .feedback li {
  margin-bottom: 30px;
}

.main_top .introduction .courseGh {
  position: relative;
  margin-bottom: 50px;
}

.main_top .introduction .courseGh .icon {
  position: absolute;
  width: 110px;
  height: 110px;
  margin-top: -10px;
  margin-left: -55px;
  top: 50%;
  left: 50%;
}

.main_top .introduction .courseGh ul {
  min-height: 80px;
  padding-top: 20px;
}

.main_top .introduction .courseGh ul li {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 590px;
  height: 80px;
  background: #ffffff;
  border-radius: 30px 30px 30px 30px;
  border: 0px solid #d8d8d8;
  margin-bottom: 20px;
  margin-right: 20px;
  float: left;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
}

.main_top .introduction .courseGh ul li:nth-child(2n) {
  margin-right: 0;
}

.main_top .introduction .courseGh .icon img {
  display: block;
  width: 110px;
  height: 110px;
}

.courseFwBox {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 220px;
  padding-right: 539px;
  background: url(../../assets/courselist/courseFw.png) right no-repeat;
  background-size: 439px 220px;
}

.main_top .introduction .courseFw ul {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.main_top .introduction .courseFw ul li {
  height: 40px;
  background: linear-gradient(
    90deg,
    rgba(135, 141, 255, 0.1) 0%,
    rgba(135, 141, 255, 0) 100%
  );
  border-radius: 26px 26px 26px 26px;
  padding: 0 10px;
  line-height: 40px;
  font-size: 16px;
  margin: 10px;
}

.main_top .introduction .courseFw ul li em {
  display: block;
  float: left;
  width: 20px;
  height: 20px;
  border: 1px solid #878dff;
  border-radius: 20px;
  margin-right: 10px;
  margin-top: 10px;
}

.main_top .feedback li h2 {
  font-weight: 500;
  font-size: 26px;
  color: #333333;
  line-height: 32px;
  text-align: left;
  margin-bottom: 10px;
}

.main_top .feedback li h2 span {
  display: block;
  width: 32px;
  height: 32px;
  background: rgba(255, 6, 89, 0.05);
  font-weight: 500;
  font-size: 24px;
  color: #ff0659;
  line-height: 32px;
  text-align: center;
  float: left;
  margin-right: 20px;
  border-radius: 16px;
}

.main_top .feedback li p {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 32px;
  text-align: left;
  padding-left: 52px;
}

.tanZzc {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
}

.yycg_tan {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 460px;
  height: 520px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(102, 102, 102, 0.6);
  border-radius: 12px;
  margin-left: -230px;
  margin-top: -280px;
  box-sizing: border-box;
  text-align: center;
}

.yycg_tan img {
  margin: 0 auto;
  margin-top: 20px;
}

.yycg_tan h2 {
  font-size: 20px;
  text-align: center;
  color: #333333;
  line-height: 24px;
  margin-top: -8px;
  margin-bottom: 30px;
}

.yycg_tan p {
  margin: 0 auto;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  margin-bottom: 38px;
}

.yycg_tan span {
  display: block;
  width: 160px;
  height: 48px;
  font-size: 20px;
  color: #333333;
  text-align: center;
  line-height: 48px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 30px;
  border: 1px solid #979797;
  -transition: 0.1s;
  cursor: pointer;
}

.yycg_tan span:hover {
  background: linear-gradient(90deg, #7782fb 0%, #4e5cf6 100%);
  color: #fff;
  border: 1px solid #fff;
}

.live_tan {
  width: 1070px;
  height: 659px;
  background: #ffffff;
  border-radius: 12px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -328px;
  margin-left: -535px;
  z-index: 9;
  padding: 0 25px;
  padding-top: 58px;
  box-sizing: border-box;
}

.live_tan span {
  position: absolute;
  top: 12px;
  left: 19px;
  cursor: pointer;
}

.live_tan video {
  border-radius: 12px;
}

.qide_modal_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2000;
}

.qide_modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.code_qide {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
}

.close_icon {
  position: absolute;
  top: 28px;
  left: 28px;
  display: inline-block;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.catalog_title_ {
  width: 1200px;
  height: 132px;
  background: #f5f6f6;
  border-radius: 8px;
  padding: 18px 14px 19px 28px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.catalog_title_ .left,
.middle_title,
.middle_money {
  float: left;
}

.catalog_title_ .right {
  float: right;
}

.catalog_title_ .left .img {
  width: 152px;
  height: 95px;
  border-radius: 8px;
}

.catalog_title_ .middle_title {
  padding: 0 23px 0 12px;
  width: 500px;
}

.middle_title .title {
  width: 500px;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}

.middle_title .tag_box .tag_item {
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  line-height: 12px;
  padding: 6px 10px;
  background: #ff8f00;
  border-radius: 4px;
  margin-right: 4px;
  display: inline-block;
}

.middle_title .tip {
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  padding: 16px 0 6px;
}

.middle_money {
  width: 200px;
  text-align: right;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.middle_money .money {
  color: #ff3a54;
  font-size: 20px;
  font-weight: bold;
}

.catalog_title_ .right {
  padding-top: 33px;
}

.catalog_title_ .right .img_ {
  width: 28px;
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/page2/courseList/course_details.vue